function ShareIcon({ color = '#00C968', width = '24', height = '24' }) {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M13.9983 3L16.4383 5.34003L8.48828 5.32001C4.91828 5.32001 1.98828 8.25003 1.98828 11.84C1.98828 13.63 2.71828 15.26 3.89828 16.44"
                stroke={color}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M9.9986 21.0005L7.55859 18.6605L15.5086 18.6805C19.0786 18.6805 22.0086 15.7505 22.0086 12.1605C22.0086 10.3705 21.2786 8.74055 20.0986 7.56055"
                stroke={color}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}

export default ShareIcon;
